import React, { useContext, useEffect, useState } from 'react'
import { FiEye, FiPlusCircle, FiXCircle } from 'react-icons/fi'

import Spinner from '../../../components/Spinner'
import Table from '../../../components/Table'

import { api, authHeaders } from '../../../services/api'

import { Container } from './styles'
import FormFormacao from '../../../components/FormFormacao'
import { concatFormacoesArray } from '../../../pages/UserViews/EspacoMedico/DadosCadastrais'
import { forceDownloadFileFromURL } from '../../../util/file'
import { extname } from '../../../util/path'
import Modal from '../../../components/Modal'
import { GlobalContext } from '../../../contexts/GlobalContext'

export default function ({ pessoa, reload, editable = true }) {
    const { checkException } = useContext(GlobalContext)

    const [showForm, setShowForm] = useState(false)
    const [initialValues, setInitialValues] = useState(null)
    const [editId, setEditId] = useState(null)
    const [openedFile, setOpenedFile] = useState(null)

    async function handlePrepareEdit(id) {
        if (!pessoa) {
            return
        }

        setEditId(id)

        const { grau, formacao, instituicao, certificado_id, instituicao_cidade_uf, instituicao_a_aprovar_descricao } = pessoa.formacoes.find(c => c.id === id) || null

        setInitialValues({
            grau: { value: grau.id, label: grau.descricao },
            formacao: concatFormacoesArray(formacao),
            instituicao: instituicao ? { value: instituicao.id, label: instituicao?.descricao } : null,
            nova_instituicao_uf_cidade: instituicao_cidade_uf,
            nova_instituicao_nome: instituicao_a_aprovar_descricao,
            certificado: certificado_id
        })

        setShowForm(true)
    }

    async function handleDelete(id) {
        try {
            await api.delete(`pessoa_formacao/${id}`, authHeaders())

            reload()

            return true
        } catch (e) {
            checkException(e)

            return false
        }
    }

    async function handleOpenCertificado(link) {
        if (!link) {
            return
        }

        if (extname(link) === '.pdf') {
            forceDownloadFileFromURL(link)
        } else {
            setOpenedFile(link)
        }
    }

    return (
        <>
            <Container className="animated fadeInUp delay-700ms">
                <h1>Formação Acadêmica</h1>

                {editable ? (
                    <>
                        {showForm ? (
                            <FiXCircle
                                size={24}
                                data-tip="Fechar"
                                data-for="tooltip"
                                style={{ gridArea: 'icon' }}
                                onClick={() => {
                                    setShowForm(false)
                                    setInitialValues(null)
                                    setEditId(null)
                                }}
                            />
                        ) : (
                            <FiPlusCircle
                                size={24}
                                data-tip="Adicionar"
                                data-for="tooltip"
                                style={{ gridArea: 'icon' }}
                                onClick={() => {
                                    setShowForm(true)
                                }}
                            />
                        )}
                    </>
                ) : (
                    <div />
                )}

                {showForm && (
                    <FormFormacao
                        formacaoInitialValues={initialValues}
                        editId={editId}
                        pessoa={pessoa}
                        style={{ gridArea: 'form' }}
                        className="animated fadeIn"
                        reload={() => {
                            reload()
                            setShowForm(false)
                            setInitialValues(null)
                            setEditId(null)
                        }}
                    />
                )}

                {pessoa ? (
                    <Table
                        headers={[
                            { name: 'grau_descricao', value: 'Grau', centered: true },
                            { name: 'formacao_descricao', value: 'Formação', centered: true },
                            { name: 'instituicao_descricao', value: 'Instituição', centered: true }
                        ]}
                        data={pessoa?.formacoes || []}
                        handlePrepareEdit={editable && handlePrepareEdit}
                        handleDelete={editable && handleDelete}
                        confirmExclusion={{
                            attr: 'formacao_descricao',
                            template: 'Deseja realmente excluir a formação #attr#?'
                        }}
                        emptyLabel="Nenhuma formação adicionada"
                        actions={[
                            {
                                action: item => handleOpenCertificado(item.certificado),
                                name: 'Abrir',
                                icon: FiEye,
                                iconSize: 16,
                                checkDisabled: item => !item.certificado,
                                disabledTooltip: 'Não anexado'
                            }
                        ]}
                    />
                ) : (
                    <Spinner />
                )}
            </Container>

            <Modal
                isOpen={!!openedFile}
                handleClose={() => {
                    setOpenedFile(null)
                }}
                title="Visualização"
            >
                <img src={openedFile} alt="" className="w-full" />
            </Modal>
        </>
    )
}
